import { DatetimeDisplayType } from 'customer-data-filters-ui/filterQueryFormat/DisplayTypes';
import DSFieldRecord from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import I18n from 'I18n';
import { DATE } from 'customer-data-objects/property/PropertyTypes';
import { EVENT_BASED_FIELD_KEYS } from 'customer-data-filters-ui/strategy/eventBasedFilters';
export const makeEventDateField = filterFamily => {
  return DSFieldRecord({
    displayType: DatetimeDisplayType,
    label: I18n.text(`newCustomerDataFilters.specialFields.${filterFamily}.${EVENT_BASED_FIELD_KEYS.EVENT_DATE}`),
    name: EVENT_BASED_FIELD_KEYS.EVENT_DATE,
    type: DATE,
    displayOrder: 2,
    refinement: true
  });
};